export function combineSignals(signals: AbortSignal[]): { signal: AbortSignal; dispose: () => void } {
  const nativeAny = (AbortSignal as typeof AbortSignal & { any?: (signals: AbortSignal[]) => AbortSignal }).any;
  if (nativeAny) return { signal: nativeAny(signals), dispose: () => {} };
  const controller = new AbortController();
  const abort = () => controller.abort();
  signals.forEach((signal) => {
    if (signal.aborted) controller.abort();
    else signal.addEventListener("abort", abort, { once: true });
  });
  return { signal: controller.signal, dispose: () => signals.forEach((signal) => signal.removeEventListener("abort", abort)) };
}
